export const enum Status {
    TODO = 1,
    INPROGRESS = 2,
    DONE = 3
}

export enum ColorTheme {
    DARK = "dark",
    LIGHT = "light"
}

export enum Keyboard {
    ESC = "Escape",
    DEL = "Delete",
    ENT = "Enter",
    TAB = "Tab"
}